import * as React from "react";
import { ForgotPasswordController } from "@njoy/controller";
import { useNavigate } from "react-router-dom";
import { ForgotPasswordView } from "./ui/ForgotPasswordView";
import * as ROUTES from "../../../constants/routes";
import { ForgotPasswordResetModal } from "../../../components/modals/forgotPasswordResetModal";

export const ForgotPasswordConnector: React.FC = () => {
  const [visible, setVisible] = React.useState(false);
  const navigate = useNavigate();

  const onFinish = () => {
    navigate(ROUTES.LOGIN);
  };

  const showModal = () => setVisible(true);

  const handleCancel = () => {
    setVisible(false);
    onFinish();
  };

  return (
    <>
      <ForgotPasswordController>
        {({ submit }) => {
          const normalizedSubmit = async (values: any) => {
            const result = await submit(values);
            if (!result) return null;
            // Transform result to NormalizedErrorMap if needed
            if (Array.isArray(result.errors)) {
              const errorMap: { [key: string]: string } = {};
              result.errors.forEach((err: { path: string; message: string }) => {
                errorMap[err.path] = err.message;
              });
              return errorMap;
            }
            return null;
          };
          return (
            <ForgotPasswordView onFinish={showModal} submit={normalizedSubmit} />
          );
        }}
      </ForgotPasswordController>

      <ForgotPasswordResetModal
        visible={visible}
        onOk={handleCancel}
        onCancel={handleCancel}
      />
    </>
  );
};